export const getDisplayTextLabelPartText = (part) => {
    return typeof part === 'string' ? part : part.text;
};
export const getDisplayTextLabelText = (label) => {
    if (!label)
        return '';
    if (Array.isArray(label))
        return label.map(getDisplayTextLabelPartText).join('');
    return getDisplayTextLabelPartText(label);
};
